import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
// import { UrlService } from '@core/services/url/url.service';
// import { Subscription } from 'rxjs';

// import { VersionsService as CoreVersionsService } from '@core/services/versions/versions.service';


import * as Objects from '@core/objects';
import { VersionFeedback, ApprovalStatusColorValues, FeedbackStatusColorValues } from '@core/models/version-feedback';
// import { Router } from '@angular/router';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
// import { FilesListItemMenuClick } from '@core/components/files/lists/files-list-item-menu-click';


@Component({
    selector: 'core-version-feedbacks-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss']
})
export class VersionFeedbacksItemComponent implements OnInit {
    
    @Input() feedback: VersionFeedback;
    @Input() user: Objects.User = null; //current user.
    // @Input() archiveFeedbackAccess: boolean = true;
    @Input() menu: Array<ThreeDotsMenuItem> = [];
    @Output() menuClick = new EventEmitter<VersionFeedback>();

    public readonly APPROVAL_STATUS_COLORS = ApprovalStatusColorValues; //['#F6B273','#47B934','#F44848'];
    public readonly FEEDBACK_STATUS_COLORS = FeedbackStatusColorValues;

    //1-> Approved: 47B934 (old'#92D77D',)
    //2-> Rejected: F44848   (old'#C8494E', )
    //3-> only comments: '#C8494E', ????


    // public menu: Array<ThreeDotsMenuItem> = [];

    // protected archiveMenu: ThreeDotsMenuItem = {
    //     title: "Archive",
    //     key: "archive-approval",
    //     icon: "archive-approval"
    // };

    ngOnInit(): void {
        // console.log(" init feedback item", this.menu);
        // if(this.archiveFeedbackAccess)
            // this.menu.push(this.archiveMenu);
    }

    // removed action december-2022 due to  feedback inside version screen
    // openFeedback(feedback: VersionFeedback){
    //     console.log("click on feedback ",feedback);
        // this.action.emit(feedback);
        // this.router.navigate(['/p/feedback/versions/'+feedback.version.id + "/users/"+feedback.user.id]);
    // }
    

    // public getApprovalColor(approval: Objects.Approval){
    //     if (approval != null)
    //         return this.APPROVAL_STATUS_COLORS[approval.status_code];
    //     return this.FEEDBACK_ONLY_COMMENT_COLOR;
    // }

    public getBubbleColor(feedback: VersionFeedback){
        if (feedback.approval != null){
            return this.APPROVAL_STATUS_COLORS[feedback.approval.status_code];
        } else {
            return this.FEEDBACK_STATUS_COLORS[feedback.status.status_code];
        }
      }

    onApprovalMenuSelect(key: string) {
        switch(key) {
            case "archive-approval":
                // this.archiveAction.emit(this.feedback);
                break;
        }
    }


}
